import React, { useState } from 'react';
import { Image, ImageProps, ImageURISource } from 'react-native';

interface ImageRetryProps extends ImageProps {
  numRetries?: number;
  source: ImageURISource;
}

export const ImageRetry: React.FC<ImageRetryProps> = ({
  numRetries = 2,
  ...rest
}) => {
  const [currentRetry, setCurrentRetry] = useState(0);

  const handleError = () => {
    if (currentRetry < numRetries) {
      setCurrentRetry((prevRetry) => prevRetry + 1);
    }
  };

  return <Image {...rest} onError={handleError} key={`${currentRetry}`} />;
};
